import { render, staticRenderFns } from "./Cantons.vue?vue&type=template&id=7486db7a&scoped=true&"
import script from "./Cantons.vue?vue&type=script&lang=js&"
export * from "./Cantons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7486db7a",
  null
  
)

export default component.exports